import script from "./Select.vue?vue&type=script&setup=true&lang=js"
export * from "./Select.vue?vue&type=script&setup=true&lang=js"

import "./Select.vue?vue&type=style&index=0&id=fc10afdc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc10afdc"]])

export default __exports__